import { useEffect, useState } from "react";
import { TextView } from "nystem-components";
import app from "nystem";

const bytLen = [
  { id: "year", nr1: "år", nr: "år" },
  { id: "month", nr1: "månad", nr: "månader" },
  { id: "day", nr1: "dag", nr: "dagar" },
];
const reccuringbyten = { year: "år", month: "månad" };

const FloatCodeprice = ({ value, ...props }) => {
  const { field, show, tofixed } = props.model;
  const [code, setCode] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const code = props.view.baseView.getValue("code");
      const { data } = await app.database.code.get({ id: code });
      if (!data) {
        setCode(false);
        return;
      }
      let add = [];
      if (data?.group) {
        const res = await app.database.product.search({
          filter: { group: data.group },
        });
        if (res.data) add = res.data.map((item) => item._id);
      }
      setCode({ ...data, product: [...data.product, ...add] });
    };
    fetchData();
    props.view.baseView.on("change", -2000, fetchData);
  }, [props.view, field, show, setCode]);

  if (!code) return null;
  const { _id } = props.view.value;
  if (!code.product.includes(_id)) return null;

  const { amount, pricetype } = code;
  const byName = {
    percent: value * (1 - amount * 0.01),
    price: amount,
    free: 0,
  };
  let out = "";
  if (props.model.show === "price") {
    out = byName[pricetype];
    if (out) {
      out = `${parseFloat(out).toFixed(tofixed).replace(".", ",")} kr`;
      const recc = props.view.getValue("recurring");
      if (recc) out += ` / ${reccuringbyten[recc]}`;
    } else out = "Gratis";
  } else if (props.model.show === "text") out = props.model.text;
  else if (props.model.show === "length") {
    out = bytLen
      .map(
        (item) =>
          code[item.id] &&
          ` ${code[item.id]} ${item[`nr${code[item.id] === 1 ? "1" : ""}`]}`,
      )
      .filter((item) => item)
      .join(", ");
  }

  return <TextView {...props} value={out} />;
};
export default FloatCodeprice;
